import { createContext, useContext } from 'react';

export type PageScrollPosition = Readonly<{
	/**
	 * undefined means we don't know yet (usually pre-hydration)
	 */
	afterDescription: boolean | undefined;
	setAfterDescription: (afterDescription: boolean) => void;
	/**
	 * undefined means we don't know yet (usually pre-hydration)
	 */
	beforeSuggestedPetitions: boolean | undefined;
	setBeforeSuggestedPetitions: (beforeSuggestedPetitions: boolean) => void;
	/**
	 * undefined means we don't know yet (usually pre-hydration)
	 */
	afterMedia: boolean | undefined;
	setAfterMedia: (afterMedia: boolean) => void;
	/**
	 * undefined means we don't know yet (usually pre-hydration)
	 */
	afterMobileActionButton: boolean | undefined;
	setAfterMobileActionButton: (afterMobileActionButton: boolean) => void;
	/**
	 * undefined means we don't know yet (usually pre-hydration)
	 */
	insideEmbeddedSignForm: boolean | undefined;
	setInsideEmbeddedSignForm: (insideEmbeddedSignForm: boolean) => void;
}>;

export const PageScrollPositionContext = createContext<PageScrollPosition | undefined>(undefined);

export function usePageScrollPosition(): PageScrollPosition {
	const context = useContext(PageScrollPositionContext);

	if (!context) {
		throw new Error('PageScrollPositionContext was not set');
	}

	return context;
}
